import React from 'react';
import PriceChecker from '../../../../components/PriceChecker';

/**
 * TODO: Выпилить и заменить на PriceChecker из src/routes/Checkout/components/PriceChecker
 */
const PriceCheckerContainer = ({ isVisible, ...props }) =>
  isVisible ? <PriceChecker {...props} /> : null;

export default PriceCheckerContainer;
